import { ShieldAlert } from 'lucide-react';

export const BlockedScreen = ({ message }) => (
  <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-secondary-900/97 backdrop-blur-md px-6" data-testid="blocked-screen">
    <div className="w-full max-w-md bg-white dark:bg-slate-800 rounded-3xl p-8 text-center shadow-2xl border-4 border-red-600">
      <div className="h-16 w-16 rounded-full bg-red-100 dark:bg-red-900/40 flex items-center justify-center mx-auto mb-4">
        <ShieldAlert className="h-9 w-9 text-red-600" />
      </div>
      <h1 className="text-2xl font-bold text-red-600 mb-2">Account Blocked</h1>
      <p className="text-sm text-secondary-800 dark:text-slate-200 mb-4" data-testid="blocked-screen-message">
        {message || 'Your account has been permanently blocked for attempting to breach platform security.'}
      </p>
      <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800/50 rounded-xl p-3 text-xs text-red-700 dark:text-red-300">
        This action has been recorded and reported, including your IP address and location.
        Only a super administrator can restore access to your account.
      </div>
    </div>
  </div>
);

export default BlockedScreen;
